module.exports = __webpack_public_path__ + "img/img-budget.1d0777d9.png";